import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bootStage: "initial",
  skipAnimation: true,
  showSkipButton: false,
};

const arcadeSlice = createSlice({
  name: "arcade",
  initialState,
  reducers: {
    setBootStage: (state, action) => {
      state.bootStage = action.payload;
      // Show skip button only when booting
      state.showSkipButton = false;
    },
    setSkipAnimation: (state, action) => {
      state.skipAnimation = action.payload;
    },
    hideSkipButton: (state) => {
      state.showSkipButton = false;
    },
    resetArcadeState: (state) => {
      state.bootStage = "initial";
      state.skipAnimation = true;
      state.showSkipButton = false;
    },
  },
});

export const {
  setBootStage,
  setSkipAnimation,
  hideSkipButton,
  resetArcadeState,
} = arcadeSlice.actions;

export default arcadeSlice.reducer;
